module.exports = __webpack_public_path__ + "static/img/best-director-3b-mob.0f19587.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/best-director-3b-mob.jpg
// module id = 58
// module chunks = 0